import Joi from 'joi';
const titleBlockSchema = Joi.object({
  type: Joi.string().valid('titleBlock').required(),
  code: Joi.string().allow('', null).optional(),
  title: Joi.string().allow('', null).optional(),
  titleLink: Joi.string().allow('', null).optional()
}).unknown(true);
export default titleBlockSchema;